export var SET_CART = 'SET_CART';
export var SET_CART_QTY = 'SET_CART_QTY';
export var SET_CART_SUCCESS = 'SET_CART_SUCCESS';
export var SET_CART_SUCCESS_SERVER = 'SET_CART_SUCCESS_SERVER';
export var SET_CART_STATE = 'SET_CART_STATE';